import {
  Component,
  HostBinding,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { UmssIconComponent } from "../icon/icon.component";

@Component({
  selector: "umss-link-button",
  standalone: true,
  imports: [CommonModule, UmssIconComponent],
  templateUrl: "./link-button.component.html",
  styleUrls: ["./link-button.component.scss"],
})
export class UmssLinkButtonComponent {
  @HostBinding("style.display") display = "contents";

  constructor() { }

  /** Content props - Clean and semantic */
  @Input() label: string = "Link Button";
  @Input() href?: string; // Optional href for actual links
  @Input() target?: '_blank' | '_self' | '_parent' | '_top' = '_self'; // Link target

  /** Icon props - Direct Phosphor icon integration */
  @Input() leftIconName?: string; // Phosphor icon name for left icon (e.g., 'phosphorCheck')
  @Input() rightIconName?: string; // Phosphor icon name for right icon (e.g., 'phosphorArrowRight')
  @Input() iconSize?: string; // Icon size (default based on button size)
  @Input() iconColor?: string; // Icon color (defaults to currentColor)

  /** Variant props - Well-typed and comprehensive */
  @Input() variant: 'primary' | 'secondary' | 'ghost' = 'ghost'; // Link buttons are typically ghost style
  @Input() size: 'mini' | 'small' | 'medium' | 'large' = 'medium';

  /** State props - Simple and clear */
  @Input() disabled: boolean = false;

  /** Events - Proper event handling */
  @Output() onClick = new EventEmitter<MouseEvent>();

  onButtonClick(event: MouseEvent) {
    if (!this.disabled) {
      this.onClick.emit(event);
    }
  }

  onLinkClick(event: MouseEvent) {
    if (this.disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    this.onClick.emit(event);
  }

  /** Computed properties */
  get computedAriaLabel(): string {
    return this.label;
  }

  get isExternalLink(): boolean {
    return this.target === '_blank';
  }

  get computedIconSize(): string {
    if (this.iconSize) return this.iconSize;
    
    // Default icon sizes based on button size
    switch (this.size) {
      case 'mini': return '12px';
      case 'small': return '14px';
      case 'medium': return '16px';
      case 'large': return '20px';
      default: return '16px';
    }
  }

  get showLeftIcon(): boolean {
    return !!this.leftIconName;
  }

  get showRightIcon(): boolean {
    return !!this.rightIconName;
  }
}
